// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"f4c61d9c","453":"f95ddc6c"}[chunkId] + ".chunk.js";
};